import clsx from 'clsx';

import { Range } from '@lib/ui';

export type TraitSliderProps = {
  leftLabel: string;
  rightLabel: string;
  value: number;
  onChange: (value: number) => void;
  className?: string;
};

function TraitSlider({ leftLabel, rightLabel, value, onChange, className }: TraitSliderProps) {
  // Determine which label is "active" based on value
  const leftActive = value < 40;
  const rightActive = value > 60;
  const neutral = !leftActive && !rightActive;

  return (
    <div className={clsx('space-y-2', className)}>
      <div className="flex items-center justify-between">
        <span
          className={clsx(
            'text-sm font-medium transition-colors',
            leftActive
              ? 'text-primary-600 dark:text-primary-400'
              : 'text-gray-500 dark:text-dark-400'
          )}
        >
          {leftLabel}
        </span>
        <span
          className={clsx(
            'text-sm font-medium transition-colors',
            rightActive
              ? 'text-primary-600 dark:text-primary-400'
              : 'text-gray-500 dark:text-dark-400'
          )}
        >
          {rightLabel}
        </span>
      </div>

      <div className="relative">
        <Range
          min={0}
          max={100}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          color={neutral ? 'neutral' : 'primary'}
          className="w-full"
        />

        {/* Value indicator */}
        <div className="mt-1 flex justify-center">
          <span
            className={clsx(
              'text-xs px-2 py-0.5 rounded-full transition-colors',
              neutral
                ? 'bg-gray-100 text-gray-600 dark:bg-dark-600 dark:text-dark-300'
                : 'bg-primary-100 text-primary-700 dark:bg-primary-900/30 dark:text-primary-300'
            )}
          >
            {leftActive && leftLabel}
            {rightActive && rightLabel}
            {neutral && 'Balanced'}
          </span>
        </div>
      </div>
    </div>
  );
}

TraitSlider.displayName = 'TraitSlider';

export { TraitSlider };
